// extracted by mini-css-extract-plugin
module.exports = {"root":"Logo_root__32W_W","lg":"Logo_lg__nVSjw"};